import React, { useEffect, useId, useRef, useState } from 'react';

/* Bouton d'aide rond « ? » : une ou deux phrases au survol, au focus et au clic.
   Le clic garde la bulle ouverte (clavier, écran tactile) ; Échap ou un clic
   ailleurs la referme. Les textes sont tous dans src/aide/textesAide.ts. */
const BoutonAide: React.FC<{ texte: string; libelle?: string }> = ({ texte, libelle = 'Aide' }) => {
  const [survol, setSurvol] = useState(false);
  const [epingle, setEpingle] = useState(false);
  const racine = useRef<HTMLSpanElement>(null);
  const id = useId();
  const ouvert = survol || epingle;

  useEffect(() => {
    if (!epingle) return;
    const fermer = (e: MouseEvent | TouchEvent) => {
      if (racine.current && !racine.current.contains(e.target as Node)) setEpingle(false);
    };
    document.addEventListener('mousedown', fermer);
    document.addEventListener('touchstart', fermer);
    return () => {
      document.removeEventListener('mousedown', fermer);
      document.removeEventListener('touchstart', fermer);
    };
  }, [epingle]);

  return (
    <span
      className="aide"
      ref={racine}
      onMouseEnter={() => setSurvol(true)}
      onMouseLeave={() => setSurvol(false)}
    >
      <button
        type="button"
        className="aide__bouton"
        aria-label={libelle}
        aria-expanded={epingle}
        aria-describedby={ouvert ? id : undefined}
        onClick={() => setEpingle(e => !e)}
        onFocus={() => setSurvol(true)}
        onBlur={() => setSurvol(false)}
        onKeyDown={e => { if (e.key === 'Escape') { setEpingle(false); setSurvol(false); } }}
      >
        ?
      </button>
      {ouvert && <span role="tooltip" id={id} className="aide__bulle">{texte}</span>}
    </span>
  );
};

export default BoutonAide;
